import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/france.png'
import _imports_1 from '@/assets/images/royaume-uni.png'
import _imports_2 from '@/assets/images/espagne.png'
import _imports_3 from '@/assets/images/italie.png'


const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = { class: "w-full h-48 bg-gray-200 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-8" }
const _hoisted_9 = { class: "space-y-6" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "space-y-6" }
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = { class: "flex items-center gap-3" }
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = { class: "border border-gray-300 rounded-md p-3 max-h-32 overflow-y-auto" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "text-sm text-gray-700" }
const _hoisted_24 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_25 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_26 = { class: "space-y-3" }
const _hoisted_27 = { class: "flex items-start gap-3" }
const _hoisted_28 = { class: "flex items-start gap-3" }
const _hoisted_29 = { class: "space-y-3" }
const _hoisted_30 = { class: "flex items-start gap-3" }
const _hoisted_31 = { class: "flex items-start gap-3" }
const _hoisted_32 = { class: "flex justify-end pt-6 border-t border-gray-200" }
const _hoisted_33 = {
  type: "submit",
  class: "inline-flex items-center px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
}

import { ref, reactive, computed, watch, onMounted } from 'vue'
import type { LookbookFormData, LookbookFiche } from '@/types/lookbook'
import type { LookbookFicheDisplay } from '@/types/lookbook-fiche'
import ModalComp from '@/components/ui/ModalComp.vue'
import LookbookFichesList from './LookbookFichesList.vue'
import LookbookFicheEditModal from './LookbookFicheEditModal.vue'
import { getMainCategories } from '@/api/categories'
import { 
  getLookbookFiches, 
  createLookbookFiche, 
  deleteLookbookFiche, 
  setFicheCouverture, 
  changeFicheOrdre,
  uploadLookbookFiche,
  updateLookbookFiche,
  getFicheProduits,
  addProduitToFiche,
  removeProduitFromFiche 
} from '@/api/lookbooks'
import type { Produit } from '@/types/produit'
import type { CategorieWithLabel } from '@/types/categorie'
import { useNotification } from '@/composables/useNotification'
import { getSellerImageUrl } from '@/config/api'

interface Props {
  initialData?: Omit<LookbookFormData, 'banniere'> & { banniere?: string; id?: number }
}

interface Emits {
  (e: 'submit', data: LookbookFormData): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LookbookForm',
  props: {
    initialData: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const fileInput = ref<HTMLInputElement>()
const selectedFile = ref<File>()
const previewUrl = ref<string>()

// Refs pour les fiches
const fiches = ref<LookbookFicheDisplay[]>([])
const isUploadingFiche = ref(false)
const fichesSection = ref<HTMLElement>()

// Notification composable
const { show } = useNotification()

// Vérifier si on est en mode édition
const isEditing = computed(() => !!props.initialData)

// Refs pour les color pickers
const couleurCadreColorPicker = ref<HTMLInputElement>()
const couleurTexteColorPicker = ref<HTMLInputElement>()

// Générer les années dynamiquement (année courante - 2 jusqu'à année courante + 1)
const availableYears = computed(() => {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let i = currentYear - 2; i <= currentYear + 1; i++) {
    years.push(i)
  }
  return years
})

// Gestion des couleurs
const couleurCadreText = ref(props.initialData?.couleurCadre || 'FFFFFF')
const couleurTexteText = ref(props.initialData?.couleurTexte || '000000')

const couleurCadreHex = computed({
  get: () => '#' + couleurCadreText.value,
  set: (val: string) => {
    couleurCadreText.value = val.replace('#', '').toUpperCase()
  }
})

const couleurTexteHex = computed({
  get: () => '#' + couleurTexteText.value,
  set: (val: string) => {
    couleurTexteText.value = val.replace('#', '').toUpperCase()
  }
})

// Synchroniser avec formData
watch(couleurCadreText, (newVal) => {
  formData.couleurCadre = newVal
})

watch(couleurTexteText, (newVal) => {
  formData.couleurTexte = newVal
})

// Catégories chargées dynamiquement depuis l'API
const categories = ref<CategorieWithLabel[]>([])

// ============= MODAL ÉDITION FICHE =============
const showEditModal = ref(false)
const ficheToEdit = ref<LookbookFicheDisplay | null>(null)
const isSavingFiche = ref(false)

const handleEditFiche = async (fiche: LookbookFicheDisplay) => {
  ficheToEdit.value = fiche
  showEditModal.value = true
}

const handleSaveFiche = async (data: { 
  fiche: LookbookFicheDisplay
  file?: File
  products: Produit[]
  descriptions: {
    francais: string
    anglais: string
    espagnol: string
    italien: string
  }
}) => {
  if (!data.fiche || !props.initialData?.id) return
  
  isSavingFiche.value = true
  
  try {
    // Si une nouvelle image est sélectionnée, l'uploader
    if (data.file) {
      const uploadResult = await uploadLookbookFiche(
        props.initialData.id,
        data.fiche.id,
        data.file
      )
      if (!uploadResult.success) {
        show('error', uploadResult.message)
        return
      }
    }
    
    // Sauvegarder les descriptions
    await updateLookbookFiche(data.fiche.id, {
      description_fr: data.descriptions.francais,
      description_en: data.descriptions.anglais,
      description_es: data.descriptions.espagnol,
      description_it: data.descriptions.italien,
    })
    
    // Charger les produits initiaux pour la comparaison
    const ficheProduits = await getFicheProduits(data.fiche.id)
    const initialProductIds = ficheProduits.map(fp => fp.id_produit)
    
    // Sauvegarder les produits associés
    const currentProductIds = data.products.map(p => p.id_produit)
    
    // Produits à ajouter (dans currentProductIds mais pas dans initialProductIds)
    const toAdd = currentProductIds.filter(id => !initialProductIds.includes(id))
    
    // Produits à supprimer (dans initialProductIds mais pas dans currentProductIds)
    const toRemove = initialProductIds.filter(id => !currentProductIds.includes(id))
    
    // Ajouter les nouveaux produits
    for (const idProduit of toAdd) {
      await addProduitToFiche(data.fiche.id, idProduit)
    }
    
    // Supprimer les produits retirés
    for (const idProduit of toRemove) {
      await removeProduitFromFiche(data.fiche.id, idProduit)
    }
    
    show('success', 'Fiche mise à jour avec succès')
    await loadFiches()
    showEditModal.value = false
  } catch (error) {
    show('error', 'Erreur lors de la mise à jour de la fiche')
  } finally {
    isSavingFiche.value = false
  }
}

// ============= MODAL SUPPRESSION FICHE =============
const showDeleteModal = ref(false)
const ficheToDelete = ref<LookbookFicheDisplay | null>(null)

const openDeleteModal = (fiche: LookbookFicheDisplay) => {
  ficheToDelete.value = fiche
  showDeleteModal.value = true
}

const closeDeleteModal = () => {
  showDeleteModal.value = false
  ficheToDelete.value = null
}

const confirmDeleteFiche = async () => {
  if (!ficheToDelete.value) return
  
  try {
    await deleteLookbookFiche(ficheToDelete.value.id)
    await loadFiches()
    show('success', 'Fiche supprimée avec succès')
    closeDeleteModal()
  } catch (error) {
    show('error', 'Erreur lors de la suppression de la fiche')
  }
}

// Charger les catégories au montage du composant
onMounted(async () => {
  try {
    categories.value = await getMainCategories()
  } catch (error) {
    // Erreur silencieuse - les catégories restent vides
  }
})

const formData = reactive<LookbookFormData>({
  titre: {
    francais: props.initialData?.titre.francais || '',
    anglais: props.initialData?.titre.anglais || '',
    espagnol: props.initialData?.titre.espagnol || '',
    italien: props.initialData?.titre.italien || ''
  },
  description: {
    francais: props.initialData?.description.francais || '',
    anglais: props.initialData?.description.anglais || '',
    espagnol: props.initialData?.description.espagnol || '',
    italien: props.initialData?.description.italien || ''
  },
  annee: props.initialData?.annee || new Date().getFullYear().toString(),
  collection: props.initialData?.collection || '', // printemps-ete ou automne-hiver
  couleurCadre: props.initialData?.couleurCadre || 'FFFFFF',
  couleurTexte: props.initialData?.couleurTexte || '000000',
  categories: props.initialData?.categories || []
})

// Watch pour mettre à jour le formulaire quand initialData change (mode édition)
watch(() => props.initialData, (newData) => {
  if (newData) {
    formData.titre = { ...newData.titre }
    formData.description = { ...newData.description }
    formData.annee = newData.annee
    formData.collection = newData.collection
    formData.couleurCadre = newData.couleurCadre
    formData.couleurTexte = newData.couleurTexte
    formData.categories = [...(newData.categories || [])]
    
    // Mettre à jour les color pickers
    couleurCadreText.value = newData.couleurCadre
    couleurTexteText.value = newData.couleurTexte
    
    // Si une bannière existe, l'afficher en prévisualisation avec timestamp pour éviter le cache
    if (newData.banniere) {
      const timestamp = new Date().getTime()
      previewUrl.value = `${newData.banniere}?t=${timestamp}`
    } else {
      previewUrl.value = ''
    }
    selectedFile.value = undefined
  } else {
    // Réinitialiser le formulaire si pas de données (nouveau lookbook)
    resetForm()
  }
}, { deep: true, immediate: true })

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files[0]) {
    selectedFile.value = target.files[0]
    formData.banniere = target.files[0]
    
    // Créer l'URL de prévisualisation
    previewUrl.value = URL.createObjectURL(target.files[0])
  }
}

const handleSubmit = () => {
  emit('submit', { ...formData })
}

const resetForm = () => {
  if (props.initialData) {
    formData.titre = { ...props.initialData.titre }
    formData.description = { ...props.initialData.description }
    formData.annee = props.initialData.annee
    formData.collection = props.initialData.collection
    formData.couleurCadre = props.initialData.couleurCadre
    formData.couleurTexte = props.initialData.couleurTexte
    formData.categories = [...props.initialData.categories]
    couleurCadreText.value = props.initialData.couleurCadre
    couleurTexteText.value = props.initialData.couleurTexte
    previewUrl.value = props.initialData.banniere || ''
    selectedFile.value = undefined
  } else {
    // Formulaire vierge
    formData.titre = { francais: '', anglais: '', espagnol: '', italien: '' }
    formData.description = { francais: '', anglais: '', espagnol: '', italien: '' }
    formData.annee = new Date().getFullYear().toString()
    formData.collection = ''
    formData.couleurCadre = 'FFFFFF'
    formData.couleurTexte = '000000'
    formData.categories = []
    formData.banniere = undefined
    couleurCadreText.value = 'FFFFFF'
    couleurTexteText.value = '000000'
    previewUrl.value = ''
    selectedFile.value = undefined
  }
}

// ============= MÉTHODES POUR LES FICHES =============

// Transformer les données de fiche du backend vers le format frontend
const transformFicheToDisplay = (fiche: LookbookFiche): LookbookFicheDisplay => {
  return {
    id: fiche.id_mod_lookbook_fiche,
    image_url: fiche.image_url ? getSellerImageUrl(fiche.image_url) : undefined,
    couverture: fiche.couverture === 1,
    ordre: fiche.ordre,
    date_creation: fiche.date_creation,
    description: {
      francais: fiche.description_fr || '',
      anglais: fiche.description_en || '',
      espagnol: fiche.description_es || '',
      italien: fiche.description_it || '',
    },
  }
}

// Charger les fiches du lookbook
const loadFiches = async () => {
  if (!props.initialData?.id) return
  
  try {
    const fichesData = await getLookbookFiches(props.initialData.id)
    fiches.value = fichesData.map(transformFicheToDisplay)
  } catch (error) {
    show('error', 'Erreur lors du chargement des fiches')
  }
}

// Ajouter une nouvelle fiche
const handleAddFiche = async (file: File | undefined) => {
  if (!file || !props.initialData?.id) return
  
  isUploadingFiche.value = true
  
  try {
    // Créer la fiche
    const newFiche = await createLookbookFiche(
      props.initialData.id, 
      fiches.value.length === 0 // Première fiche = couverture
    )
    
    // Upload de l'image
    const uploadResult = await uploadLookbookFiche(
      props.initialData.id,
      newFiche.id_mod_lookbook_fiche,
      file
    )
    
    if (uploadResult.success) {
      // Recharger les fiches
      await loadFiches()
      show('success', 'Fiche ajoutée avec succès')
    } else {
      show('error', uploadResult.message)
    }
  } catch (error) {
    show('error', 'Erreur lors de l\'ajout de la fiche')
  } finally {
    isUploadingFiche.value = false
  }
}

// Supprimer une fiche
const handleDeleteFiche = async (fiche: LookbookFicheDisplay) => {
  openDeleteModal(fiche)
}

// Définir une fiche comme couverture
const handleSetCouverture = async (fiche: LookbookFicheDisplay) => {
  try {
    await setFicheCouverture(fiche.id)
    await loadFiches()
    show('success', 'Couverture mise à jour')
  } catch (error) {
    show('error', 'Erreur lors de la mise à jour de la couverture')
  }
}

// Changer l'ordre d'une fiche
const handleChangeOrdre = async (fiche: LookbookFicheDisplay, direction: 'prev' | 'next') => {
  try {
    await changeFicheOrdre(fiche.id, direction)
    await loadFiches()
  } catch (error) {
    show('error', 'Erreur lors du changement d\'ordre')
  }
}

// Charger les fiches quand on passe en mode édition
watch(() => props.initialData?.id, (newId) => {
  if (newId) {
    loadFiches()
  } else {
    fiches.value = []
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"]),
      class: "space-y-8"
    }, [
      (isEditing.value)
        ? (_openBlock(), _createBlock(LookbookFichesList, {
            key: 0,
            ref_key: "fichesSection",
            ref: fichesSection,
            fiches: fiches.value,
            "is-uploading": isUploadingFiche.value,
            onAddFiche: handleAddFiche,
            onEditFiche: handleEditFiche,
            onDeleteFiche: handleDeleteFiche,
            onSetCouverture: handleSetCouverture,
            onChangeOrdre: handleChangeOrdre
          }, null, 8, ["fiches", "is-uploading"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Informations générales", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Bannière de la page lookbook ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("input", {
                ref_key: "fileInput",
                ref: fileInput,
                type: "file",
                accept: "image/*",
                onChange: handleFileChange,
                class: "hidden"
              }, null, 544),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fileInput.value?.click())),
                class: "inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              }, " Choisir un fichier "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(selectedFile.value ? selectedFile.value.name : 'Aucun fichier choisi'), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Aperçu de la bannière de la page lookbook ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (!previewUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[23] || (_cache[23] = [
                    _createElementVNode("div", { class: "text-gray-500 text-sm" }, "max-width:1280px", -1)
                  ])))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: previewUrl.value,
                    alt: "Aperçu bannière",
                    class: "max-w-full max-h-full object-contain rounded-lg"
                  }, null, 8, _hoisted_7))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Collection (Année)", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.annee) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "-- Sélectionner une année --", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: year,
                  value: year.toString()
                }, _toDisplayString(year), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, formData.annee]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Saison", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.collection) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            }, _cache[28] || (_cache[28] = [
              _createElementVNode("option", { value: "" }, "-- Sélectionner une saison --", -1),
              _createElementVNode("option", { value: "printemps-ete" }, "Printemps / Été", -1),
              _createElementVNode("option", { value: "automne-hiver" }, "Automne / Hiver", -1)
            ]), 512), [
              [_vModelSelect, formData.collection]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Couleur du cadre", -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  ref_key: "couleurCadreColorPicker",
                  ref: couleurCadreColorPicker,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((couleurCadreHex).value = $event)),
                  type: "color",
                  class: "absolute inset-0 opacity-0 w-full h-full cursor-pointer"
                }, null, 512), [
                  [_vModelText, couleurCadreHex.value]
                ]),
                _createElementVNode("div", {
                  class: "flex items-center gap-3 px-3 py-2 border border-gray-300 rounded-md cursor-pointer hover:border-indigo-400 transition-colors",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (couleurCadreColorPicker.value?.click()))
                }, [
                  _createElementVNode("div", {
                    class: "w-8 h-8 rounded border border-gray-300",
                    style: _normalizeStyle({ backgroundColor: couleurCadreHex.value })
                  }, null, 4),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((couleurCadreText).value = $event)),
                    type: "text",
                    placeholder: "FFFFFF",
                    maxlength: "6",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                    class: "flex-1 outline-none uppercase"
                  }, null, 512), [
                    [_vModelText, couleurCadreText.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Couleur du texte", -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  ref_key: "couleurTexteColorPicker",
                  ref: couleurTexteColorPicker,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((couleurTexteHex).value = $event)),
                  type: "color",
                  class: "absolute inset-0 opacity-0 w-full h-full cursor-pointer"
                }, null, 512), [
                  [_vModelText, couleurTexteHex.value]
                ]),
                _createElementVNode("div", {
                  class: "flex items-center gap-3 px-3 py-2 border border-gray-300 rounded-md cursor-pointer hover:border-indigo-400 transition-colors",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (couleurTexteColorPicker.value?.click()))
                }, [
                  _createElementVNode("div", {
                    class: "w-8 h-8 rounded border border-gray-300",
                    style: _normalizeStyle({ backgroundColor: couleurTexteHex.value })
                  }, null, 4),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((couleurTexteText).value = $event)),
                    type: "text",
                    placeholder: "000000",
                    maxlength: "6",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                    class: "flex-1 outline-none uppercase"
                  }, null, 512), [
                    [_vModelText, couleurTexteText.value]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Titre", -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[32] || (_cache[32] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Français",
                  class: "w-6 h-4"
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.titre.francais) = $event)),
                  type: "text",
                  placeholder: "-",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, formData.titre.francais]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[33] || (_cache[33] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Anglais",
                  class: "w-6 h-4"
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.titre.anglais) = $event)),
                  type: "text",
                  placeholder: "-",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, formData.titre.anglais]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[34] || (_cache[34] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: "Espagnol",
                  class: "w-6 h-4"
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.titre.espagnol) = $event)),
                  type: "text",
                  placeholder: "-",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, formData.titre.espagnol]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[35] || (_cache[35] = _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Italien",
                  class: "w-6 h-4"
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.titre.italien) = $event)),
                  type: "text",
                  placeholder: "-",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, formData.titre.italien]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Catégories", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: category.id_categorie,
                    class: "flex items-center"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: category.id_categorie,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.categories) = $event)),
                      class: "mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    }, null, 8, _hoisted_22), [
                      [_vModelCheckbox, formData.categories]
                    ]),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(category.libelle), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Description", -1)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[38] || (_cache[38] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Français",
                class: "w-6 h-4 mt-2"
              }, null, -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.description.francais) = $event)),
                rows: "4",
                placeholder: "-",
                class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
              }, null, 512), [
                [_vModelText, formData.description.francais]
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[39] || (_cache[39] = _createElementVNode("img", {
                src: _imports_1,
                alt: "Anglais",
                class: "w-6 h-4 mt-2"
              }, null, -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.description.anglais) = $event)),
                rows: "4",
                placeholder: "-",
                class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
              }, null, 512), [
                [_vModelText, formData.description.anglais]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[40] || (_cache[40] = _createElementVNode("img", {
                src: _imports_2,
                alt: "Espagnol",
                class: "w-6 h-4 mt-2"
              }, null, -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.description.espagnol) = $event)),
                rows: "4",
                placeholder: "-",
                class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
              }, null, 512), [
                [_vModelText, formData.description.espagnol]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[41] || (_cache[41] = _createElementVNode("img", {
                src: _imports_3,
                alt: "Italien",
                class: "w-6 h-4 mt-2"
              }, null, -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.description.italien) = $event)),
                rows: "4",
                placeholder: "-",
                class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
              }, null, 512), [
                [_vModelText, formData.description.italien]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", _hoisted_33, [
          _cache[43] || (_cache[43] = _createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(props.initialData ? 'Modifier' : 'Créer'), 1)
        ])
      ])
    ], 32),
    _createVNode(ModalComp, {
      isVisible: showDeleteModal.value,
      "onUpdate:isVisible": _cache[20] || (_cache[20] = ($event: any) => (showDeleteModal.value = $event)),
      onConfirm: confirmDeleteFiche,
      title: "Supprimer la fiche",
      content: "Êtes-vous sûr de vouloir supprimer cette fiche ? Cette action est irréversible.",
      cancelText: "Annuler",
      confirmText: "Supprimer",
      size: "sm"
    }, {
      header: _withCtx(() => _cache[44] || (_cache[44] = [
        _createElementVNode("div", { class: "flex items-center" }, [
          _createElementVNode("div", { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mr-3" }, [
            _createElementVNode("i", { class: "fas fa-exclamation-triangle text-red-600 text-xl" })
          ]),
          _createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, "Supprimer la fiche")
        ], -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: closeDeleteModal,
          class: "px-4 py-2 bg-gray-300 text-gray-800 text-base font-medium rounded-md shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300"
        }, " Annuler "),
        _createElementVNode("button", {
          onClick: confirmDeleteFiche,
          class: "px-4 py-2 bg-red-600 text-white text-base font-medium rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
        }, " Supprimer ")
      ]),
      _: 1
    }, 8, ["isVisible"]),
    _createVNode(LookbookFicheEditModal, {
      "is-visible": showEditModal.value,
      fiche: ficheToEdit.value,
      "is-saving": isSavingFiche.value,
      "onUpdate:isVisible": _cache[21] || (_cache[21] = ($event: any) => (showEditModal.value = $event)),
      onSave: handleSaveFiche
    }, null, 8, ["is-visible", "fiche", "is-saving"])
  ], 64))
}
}

})